import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=359ab95c"
import script from "./OtpInput.vue?vue&type=script&lang=js"
export * from "./OtpInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports